export default __webpack_public_path__ + "static/media/24847-confirmation.70519057.gif";